module.exports = __webpack_public_path__ + "img/btn-key.ac2fd521.svg";